var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticStyle: { "max-width": "600px" } }, [
    !_setup.showMe ? _c("div", [_vm._v("устарело")]) : _vm._e(),
    _vm._v(" "),
    _setup.showMe
      ? _c("div", [
          _c(
            "h1",
            [
              _setup.afterbook.bookData.offer
                ? [_vm._v("\n                Заявка создана!\n            ")]
                : [
                    _vm._v(
                      _vm._s(
                        _setup.afterbook.status.ok
                          ? "Забронировано!"
                          : "Заявка должна появиться в личном кабинете"
                      )
                    ),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _setup.afterbook.claim_num
            ? _c("div", { staticClass: "p" }, [
                _c("a", { attrs: { href: _setup.href } }, [
                  _vm._v(
                    "Перейти к заявке " + _vm._s(_setup.afterbook.claim_num)
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_setup.afterbook.status.ok
            ? _c("div", { staticClass: "dobook_wait" }, [
                _c("h2", [
                  _vm._v(
                    "В " + _vm._s(_setup.ts_plus) + " проверьте личный кабинет"
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "l" }, [
                  _vm._v("Бронирование может длиться вплоть до 10 минут"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "l" }, [
                  _vm._v(
                    "Пожалуйста не заводите повторную заявку, пока не проверите личный кабинет"
                  ),
                ]),
                _vm._v(" "),
                _setup.is
                  ? _c("div", { staticClass: "tm" }, [
                      _vm._v(_vm._s(_setup.leave_min)),
                    ])
                  : _c("div", { staticClass: "l" }, [
                      _c("a", { attrs: { href: "/workspace/tours/" } }, [
                        _vm._v("Перейти в личный кабинет"),
                      ]),
                    ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_setup.afterbook.bookData.offer
            ? _c(
                "div",
                { staticClass: "p" },
                [
                  _vm._v(
                    "\n            Предварительная стоимость без учета некоторых скидок \n            "
                  ),
                  _c(_setup.PriceCurrencyV, {
                    staticClass: "price",
                    attrs: { sum: true, price: _setup.pre_price },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "p" },
            _vm._l(_setup.messagelist, function (str) {
              return _c("p", [_vm._v(_vm._s(str))])
            }),
            0
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }